import { Theme, ThemeOptions } from '@mui/material';
import { getTypographyOverrides } from './typography';
import { getButtonOverrides } from './button';
import { getTextFieldOverrides } from './textField';
import material3 from '../material3';

export const getOverrides = (theme: Theme): ThemeOptions['components'] => ({
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: material3.color.surface,
        color: material3.color.textPrimary,
        fontFamily: material3.typography.fontFamily,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        borderRadius: material3.shape.small,
        margin: '2px 8px',
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: material3.shape.large,
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: theme.palette.primary.main,
      }
    }
  },
  ...getTypographyOverrides(theme),
  ...getButtonOverrides(theme),
  ...getTextFieldOverrides(theme)
});
